// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES } from 'router';

// hooks
import { useCareProfile } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';

// components
import { FormCompletePage } from '@karehero/llama/pwa/pages/FormCompletePage/FormCompletePage';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * FinancialStatusComplete is the page displayed for completing the financial status process.
 */
export const FinancialStatusComplete = () => {
  // hooks
  const navigate = useNavigate();
  const goBack = useGoBack();
  const { toLastFormPage, category, handleSubmit } = useCareProfile({
    categoryID: CareProfileCategoryID.FinancialStatus,
  });

  // methods
  const handleNext = useCallback(() => {
    handleSubmit();
    navigate(DYNAMIC_ROUTES.ACTION_PLAN_ITEM('get-my-funding-guide'), {
      replace: true,
    });
  }, [handleSubmit, navigate]);

  return (
    <FormCompletePage
      onBack={goBack}
      title='Financial Status'
      isComplete={category?.progress?.isComplete || false}
      items={[
        {
          icon: 'check-circle',
          text: 'Review your Financial Status answers to ensure all the needs captured are correct',
        },
        {
          icon: 'user',
          text: 'Once submitted you can chat to your Care Expert regarding your Financial Status',
        },
        {
          icon: 'file-contract',
          text: 'Your Care Expert will now provide you with your Funding Guide',
        },
      ]}
      onSubmit={handleNext}
      onPrevious={() =>
        navigate(toLastFormPage, { replace: true, state: { back: true } })
      }
      isSubmitDisabled={!category?.progress?.isComplete}
    />
  );
};

FinancialStatusComplete.displayName = 'FinancialStatusComplete';
export default FinancialStatusComplete;
